import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, finalize, tap} from "rxjs/operators";
import {lastMap} from "../../rxjs/lastMap";
import {Expiration} from "../../interfaces/Expiration";

@Component({
  selector: 'app-qr',
  template: '<div #component><qrcode [qrdata]="qrData" allowEmptyString="true" [width]="qrWidth()" [errorCorrectionLevel]="\'M\'"></qrcode></div>',
  styleUrls: []
})
export class QrComponent extends PlayerBase {
  qrData = "";

  constructor(protected  injector: Injector) {
    super(injector);
  }

  qrWidth() {
    return Math.min(this.actualWidth, this.actualHeight);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.showMsg(null, null);
        const textSource = this.data.Text[0].$.textSource;
        if (textSource == "static") {
          const data = this.data.Text[0]._;
          return of((data==null) ? "" : data);
          //return (data==null) ? of("") : of(data);
        } else if (textSource == "dynamic") {
          const url = this.data.Text[0].$.url;
          if (url=="") {
            this.showMsg(this.playerObject.$.label, "URL not exist");
            return of(null);
          } else {
            return this.playerService.caching.requestText(url, 'qr', Expiration.Now, this.playerService.getProxyUrl()).pipe(
              switchMap( res => {
                  if (res!=null && res!="") {
                    if (res.length < 512) {
                      return of(res);
                    } else {
                      return of(res.substring(0, 511) + "...");
                    }
                  }
              }),
              catchError(err => {
                this.showMsg(this.playerObject.$.label, "Error 404: page not found");
                return of(null);
              }),
            )
          }
        } else {
          this.showMsg(this.playerObject.$.label, "Supported only in legacy player");
          return of(null);
        }
      }),
      switchMap( qr => {
        if (qr!=null) {
          this.qrData = qr;
          this.changeDetectorRef.detectChanges();
        }
        return of(self)
      }),
      takeUntil(this.finish$)
    )
  }
}
